/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrows-double': {
    width: 8,
    height: 13,
    viewBox: '0 0 8 13',
    data: '<defs><path pid="0" d="M.296 9.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H.996c-.89 0-1.33 1.08-.7 1.71z" id="svgicon_arrows-double_a"/><path pid="1" d="M.296 1.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H.996c-.89 0-1.33 1.08-.7 1.71z" id="svgicon_arrows-double_b"/></defs><g _fill="#004CD0" fill-rule="evenodd"><use xlink:href="#svgicon_arrows-double_a"/><use transform="rotate(180 3.59 2.296)" xlink:href="#svgicon_arrows-double_b"/></g>'
  }
})
